module.exports = __webpack_public_path__ + "static/media/social-entrepreneur-list-new.206aeb2d.jpeg";